

import { mapState } from "pinia";
import { defineComponent } from "vue";
import { useStationStore } from "~/store/station.store";

export default defineComponent({

    computed: {
        ...mapState(useStationStore, ['group'])
    }
})

